import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Loading } from '@components/ui/loading/loading';
import { formatDatabaseSizeBytes, readDiskVolume } from '@app/pages/admin/orchestration-database-connections.util';
import {
  ObjectStorageSnapshot,
  objectStorageBucketCount,
  objectStorageLatestWriteAt,
} from '@app/pages/admin/orchestration-object-storage.util';

@Component({
  selector: 'app-orchestration-object-storage-board',
  standalone: true,
  imports: [DatePipe, TranslateModule, Loading],
  templateUrl: './orchestration-object-storage-board.html',
  styleUrl: './orchestration-object-storage-board.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationObjectStorageBoardComponent {
  readonly snapshot = input<ObjectStorageSnapshot | null>(null);
  readonly errorMessage = input('');
  readonly loading = input(false);
  readonly heading = input('');
  readonly labelledBy = input('');

  readonly boardLabelledBy = computed(() => this.labelledBy() || 'object-storage-board-title');
  readonly totalSizeLabel = computed(() => formatDatabaseSizeBytes(this.snapshot()?.totalSizeBytes ?? 0));
  readonly objectCount = computed(() => this.snapshot()?.totalObjectCount ?? 0);
  readonly bucketCount = computed(() => objectStorageBucketCount(this.snapshot()));
  readonly latestWriteAt = computed(() => objectStorageLatestWriteAt(this.snapshot()));
  readonly disk = computed(() => readDiskVolume(this.snapshot()));
  readonly diskAvailableLabel = computed(() => formatDatabaseSizeBytes(this.disk().availableBytes));
  readonly diskTotalLabel = computed(() => formatDatabaseSizeBytes(this.disk().totalBytes));
  readonly showDisk = computed(() => this.disk().availableBytes != null && this.disk().totalBytes != null);
}
